export { default } from './SliderControlBullets';
